export enum StatusTheme {
  SAVED = 'saved',
  SAVING = 'saving',
  ERROR = 'error',
}
